// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrionGlobal_dashboard_card_orion__ZjYTm {
  font-size: 1.1em;
  color: #000;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: 0.5s;
  background: #fff;
  border: solid 1px #c3c3c3;
  box-shadow: 1px 1px 25px #33333320;
  padding: 45px 15px 45px 15px;
  margin-top: 20px;
  width: 100%;
}

.OrionGlobal_dashboard_card_orion__ZjYTm img {
  width: 50px;
}

.OrionGlobal_dashboard_card_orion__ZjYTm span {
  display: block;
  padding-top: 15px;
  font-weight: 600;
  line-height: 25px;
}

.OrionGlobal_dashboard_card_orion__ZjYTm:hover {
  box-shadow: 1px 1px 25px #999;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/OrionGlobal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".dashboard_card_orion {\n  font-size: 1.1em;\n  color: #000;\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n  transition: 0.5s;\n  background: #fff;\n  border: solid 1px #c3c3c3;\n  box-shadow: 1px 1px 25px #33333320;\n  padding: 45px 15px 45px 15px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.dashboard_card_orion img {\n  width: 50px;\n}\n\n.dashboard_card_orion span {\n  display: block;\n  padding-top: 15px;\n  font-weight: 600;\n  line-height: 25px;\n}\n\n.dashboard_card_orion:hover {\n  box-shadow: 1px 1px 25px #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard_card_orion": `OrionGlobal_dashboard_card_orion__ZjYTm`
};
export default ___CSS_LOADER_EXPORT___;
